import React, { useState, useEffect } from 'react';
import './SoundSettingsModal.css';
import { getUILoc } from '../../utils/cardUtils.js';
import audioManager from '../../utils/AudioManager.js';

const SoundSettingsModal = ({ isOpen, onClose }) => {
  const [volumes, setVolumes] = useState({ ...audioManager.volumes });
  const [isMuted, setIsMuted] = useState(audioManager.isMuted);

  // モーダルが開かれたときにAudioManagerの最新の状態を同期する
  useEffect(() => {
    if (isOpen) {
      setVolumes({ ...audioManager.volumes });
      setIsMuted(audioManager.isMuted);
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const handleVolumeChange = (type, value) => {
    const floatValue = parseFloat(value);
    setVolumes(prev => ({ ...prev, [type]: floatValue }));
    audioManager.setVolume(type, floatValue);
  };

  const handleMuteToggle = () => {
    const newMute = !isMuted;
    setIsMuted(newMute);
    audioManager.setMute(newMute);
  };

  return (
    <div className="sound-modal-overlay" onClick={onClose}>
      <div className="sound-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="sound-modal-header">
          <h3>{getUILoc('SOUND_SETTINGS.TITLE')}</h3>
          <button onClick={onClose} className="sound-modal-close-button">&times;</button>
        </div>
        
        <div className="sound-modal-body">
          <div className="setting-group">
            <label>{getUILoc('SOUND_SETTINGS.MASTER')}</label>
            <input 
              type="range" 
              min="0" 
              max="1" 
              step="0.01" 
              value={volumes.master} 
              onChange={(e) => handleVolumeChange('master', e.target.value)}
            />
            <span className="value-display">{Math.round(volumes.master * 100)}%</span>
          </div>

          <div className="setting-group">
            <label>{getUILoc('SOUND_SETTINGS.BGM')}</label>
            <input 
              type="range" 
              min="0" 
              max="1" 
              step="0.01" 
              value={volumes.bgm} 
              onChange={(e) => handleVolumeChange('bgm', e.target.value)}
            />
            <span className="value-display">{Math.round(volumes.bgm * 100)}%</span>
          </div>

          <div className="setting-group">
            <label>{getUILoc('SOUND_SETTINGS.SE')}</label>
            <input 
              type="range" 
              min="0" 
              max="1" 
              step="0.01" 
              value={volumes.se} 
              onChange={(e) => handleVolumeChange('se', e.target.value)}
            />
            <span className="value-display">{Math.round(volumes.se * 100)}%</span>
          </div>

          <div className="setting-group mute-group">
            <label>{getUILoc('SOUND_SETTINGS.MUTE')}</label>
            <input 
              type="checkbox" 
              checked={isMuted} 
              onChange={handleMuteToggle}
            />
          </div>
        </div>

        <div className="sound-modal-footer">
          <button onClick={onClose} className="sound-modal-close-button-bottom">
            {getUILoc('SOUND_SETTINGS.CLOSE')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SoundSettingsModal;
